module.exports = __webpack_public_path__ + "static/media/content.f126fe30.svg";